import React, { useState } from 'react';
import ReactPlayer from 'react-player';

import { getThemeClass } from '../../tools/textTools';
import { CustomModal } from '../BrandCampaign/BrandCampaignHero';
import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './VisualBelowHeadline.module.scss';

export default function VisualBelowHeadline({ section }) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const themeClass = getThemeClass(section.colorTheme?.themeName);

  return (
    <PageSection
      slim
      className={themeClass}
      innerClassName={styles.visualBelowHeadline}
      data-analytics-component={'visual-below-headline'}
      data-analytics-id={section.title}
    >
      <div className={styles.leftColumn}>
        <span className={[styles.eyebrow, 'themed-eyebrow'].join(' ')}>{section.subtitle}</span>
        <h2 className={styles.title}>{section.title}</h2>
        {section.mainImage &&
          (section.wistiaUrl ? (
            <>
              <button
                className={styles.videoTrigger}
                onClick={handleOpen}
                onKeyDown={(e) => e.key === 'Enter' && handleOpen()}
              >
                <ContentfulImage imageFragment={section.mainImage} className={styles.thumbnail} />
              </button>
              <CustomModal open={open} onClose={handleClose}>
                <ReactPlayer url={section.wistiaUrl} playing={open} controls={false} width="100%" />
              </CustomModal>
            </>
          ) : (
            <ContentfulImage imageFragment={section.mainImage} className={styles.thumbnail} />
          ))}
      </div>
      <div>
        <RichTextConverter copy={section.copy} />
      </div>
    </PageSection>
  );
}
